import { cn } from '@/lib/utils';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
  color?: 'default' | 'primary' | 'secondary';
}

/**
 * Displays a loading spinner animation
 * @param size - Size of the spinner ('sm' | 'md' | 'lg')
 * @param className - Additional CSS classes
 * @param label - Accessibility label
 * @param color - Color variant of the spinner
 */
export function LoadingSpinner({ 
  size = 'md', 
  className,
  label = 'Loading...',
  color = 'default'
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  const colorClasses = {
    default: 'text-foreground',
    primary: 'text-primary',
    secondary: 'text-secondary'
  };

  return (
    <div 
      role="status" 
      aria-label={label}
      className={cn('animate-spin', colorClasses[color], className)}
    >
      <svg
        className={cn(sizeClasses[size])}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
} 